/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";

const useChangeLibraryListByCampus = ({
    currentResourceForUpdate = null,
    campusId, 
    libraryList,
    changeLibraryField
}) => {
    const [libraryListByCampus, setLibraryListByCampus] = useState([]);
    useEffect(() => {
        if (campusId === 0) {
            setLibraryListByCampus([]);
            return;
        }
        setLibraryListByCampus(libraryList.filter(library => library.campusId === campusId));
        if (currentResourceForUpdate !== null && currentResourceForUpdate.libraryId !== 0) return;
        changeLibraryField(0, "");
    }, [campusId, libraryList]);
    return {
        libraryListByCampus
    };
}
export default useChangeLibraryListByCampus;